import { createContext } from 'react';
import type { TrackingService } from './tracking-service';

export const TrackingContext = createContext<TrackingService | null>(null);
